import { useTheme } from "../../context/ThemeContext";

// Theme-dependent classes shared by the landing sections. The global light-mode
// overrides in tailwind.css cover most dark classes, but accent fills and focus
// rings need an explicit per-theme choice to keep AA contrast.
export default function useLandingTheme() {
  const { theme } = useTheme();
  const isLight = theme === "light";

  return {
    isLight,
    focusRing: isLight
      ? "focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-[#712CB0]"
      : "focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-[#FF43A7]",
    // White on the pink accent is only 3:1, so dark mode uses midnight text on
    // pink, and light mode the solid brand purple with white text.
    accentFill: isLight
      ? "tw-bg-[#712CB0] tw-text-white"
      : "tw-bg-[#FF43A7] tw-text-midnight",
  };
}
